import { gql } from '@apollo/client';

export const TEMPLATE_DETAILS = gql`
  fragment TemplateDetailsFragment on Template {
    _id
    title
    typeId
    userId
    canEdit
    type
    isPublic
    deepLink
    image {
      squareUrl
      rectUrl
      cropped {
        small
        medium
      }
    }
    daysCountBeforeLock
    location {
      name
      lat
      lng
    }
    arrivalTime
    startTime
    endTime
    settings {
      canHostsInviteGuests
      canGuestsInviteGuests
      canHostCreateSections
      canHostReorderSections
      canHostChangeHeadlineColors
      sectionSongsLimit
      sectionMustPlayLimit
      canHostChangeEventColor
      canHostAddSectionImages
      canHostChangeEventCoverPhoto
      disableAllPushNotifications
      disabledNotifications
    }
    emailMessage {
      host
      guest
    }
    textMessage {
      host
      guest
    }
    eventColors {
      customEventLightModeColor
      customEventDarkModeColor
      defaultEventLightModeColor
      defaultEventDarkModeColor
    }
    allowedFeatures {
      _id
      name
      createdAt
    }
    isPro
    customNotificationsCount
  }
`;

export const TEMPLATE_PUBLIC = gql`
  fragment TemplatePublic on Template {
    isPublic
  }
`;

export const TEMPLATE_NOTIFS_COUNT = gql`
  fragment TemplateNotifsCountFragment on Template {
    customNotificationsCount
  }
`;
